import { render } from "./AdminLogs.vue?vue&type=template&id=8273c1a8&scoped=true"
import script from "./AdminLogs.vue?vue&type=script&lang=js"
export * from "./AdminLogs.vue?vue&type=script&lang=js"

import "./AdminLogs.vue?vue&type=style&index=0&id=8273c1a8&scoped=true&lang=css"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8273c1a8"]])

export default __exports__